import { styled, Box, List } from "@mui/material";

export const PopUpTechDataAndContactRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: "5rem 1rem",
  boxSizing: "border-box",
  backdropFilter: "blur(0.5rem)",
  width: "95dvw",
  height: "fit-content",
  maxHeight: "95dvh",
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  gap: 10,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  margin: "auto",
  background: `rgba(${theme?.palette?.companyColors?.blackRGB}, 0.8)`,
  borderRadius: theme?.borderRadius?.small,
  [theme.breakpoints.up("lg")]: {
    padding: "3rem",
    width: "80dvw",
    borderRadius: theme?.borderRadius?.big,
  },
  [theme.breakpoints.up("xl")]: {
    padding: "5rem",
    width: "60dvw",
    gap: 20,
  },
}));

export const PopUpTechDataAndContactHeader = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: 10,
  marginBottom: 0,
  [theme.breakpoints.up("xl")]: {
    gap: 10,
    marginBottom: 20,
  },
}));

export const PopUpTechDataAndContactContent = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "auto",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 20,
}));

export const PopUpTechDataAndContactList = styled(List)(({ theme }) => ({
  width: "100%",
  zIndex: 1,
  borderRadius: theme?.borderRadius?.default,
  maxHeight: "43dvh",
  overflowY: "auto",
  background: `rgba(${theme.palette.companyColors.neutralRGB}, 0.65)`,
  borderRight: "2px solid #fff",
  "&::-webkit-scrollbar-track": {
    marginTop: 2,
    marginBottom: 2,
  },
}));

export const PopUpTechDataAndContactFooter = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 15,
}));
